import React from 'react';
import { useNavigate } from 'react-router-dom';

interface DashboardCardProps {
  title: string;
  description: string;
  route: string;
  icon?: React.ReactNode;
}

export const DashboardCard: React.FC<DashboardCardProps> = ({ 
  title, 
  description, 
  route, 
  icon
}) => {
  const navigate = useNavigate();

  return (
    <div 
      onClick={() => navigate(route)}
      style={{
        width: '100%',
        background: 'var(--card-bg)',
        border: '1px solid var(--border-color)',
        borderRadius: '12px',
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
        position: 'relative',
        overflow: 'hidden'
      }}
      className="dashboard-card"
    >
      {icon && (
        <div style={{ 
          marginRight: '20px', 
          color: 'var(--accent-color)',
          fontSize: '28px',
          opacity: 0.7
        }}>
          {icon}
        </div>
      )}
      <div>
        <h2 style={{
          margin: '0 0 8px 0',
          fontSize: '18px',
          fontWeight: 600,
          color: 'var(--text-primary)'
        }}>
          {title}
        </h2>
        <p style={{
          margin: 0,
          color: 'var(--text-secondary)',
          fontSize: '14px'
        }}>
          {description}
        </p>
      </div>
    </div>
  );
};